export const STATUS_MAPPING = {
  TO_BE_PROCESSED: "Upload Pending",
  PROCESSING: "Processing",
  EXPORTING: "Exporting",
  EXPORTED: "Ready for review",
  COMPLETED: "Uploaded",
} as const;

/** Badge color per status, keyed the same as STATUS_MAPPING. */
export const STATUS_BADGE_VARIANT: Record<
  keyof typeof STATUS_MAPPING,
  "default" | "warning" | "success"
> = {
  TO_BE_PROCESSED: "default",
  PROCESSING: "warning",
  EXPORTING: "warning",
  EXPORTED: "success",
  COMPLETED: "success",
};
